export enum TestValidationErrorTarget {
  Test = 'test',
  Question = 'question',
  Answer = 'answer',
  Result = 'result',
}
